export const Container = ({children}) => {
    return (
        <div className="site__container">
            {children}
        </div>
    )
}